export const BOOKING_IN_SHOP_SELECTION = [
  { value: "ARRIVE", label: "Arrive at shop" },
  { value: "ARRIVED", label: "Customer already arrived" },
];

export const BOOKING_API_URL = process.env.NEXT_PUBLIC_API_URL || "/api";

export const BOOKING_SELECTION = `
    id
    customerNumber
    code
    bookingDate
    startTime
    status
    note
    phone
    populatedUser {
        id
        name
    }
    shop {
        id
        name
        displayedAddress
        avatar {
            url
            alt
        }
        bookingDayOfWeek {
            dayOfWeek
            startTime
            endTime
            timeGap
            bookingNumberLimit
        }
    }
    serviceTransaction {
        quantity
        originalPrice
        discount
        finalPrice
        voucher {
          id
          code
        }
        service {
          id
          name
          menuPrice
        }
        campaignPackage {
          id
          displayName
          type
        }

    }
    totalOriginalPrice
    totalDiscount
    totalFinalPrice
    createdAt
    updatedAt
`;
